
import { useState } from "react"
import { GET_STOCK_CATEGORIES } from "../../apis/configuration";
import { handleApi } from "../../apis";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

/**
 * Custom hook to return categories, sub_categories & brands
 * @returns categories & loading
 */

const useGetCategories = () => {

    const [catLoading, setCatLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const navigate = useNavigate();
    /**
     * Get cateogries
     */

    const getCategories = () => {
        setCatLoading(true);
        let map = {};

        return new Promise((resolve, reject) => {
            handleApi(GET_STOCK_CATEGORIES, {},null,navigate).then(res => {
                const categories = res?.super_categories?.[0]?.categories || [];

                categories.map(value => map[value.name] = value);

                setCategories(map);
                setCatLoading(false);
                resolve();
            }).catch(err => {
                setCatLoading(false);
                toast.error(err?.response?.data?.message || "Something went wrong", {className:'errorToast'})
                reject(err);
            });
        })
    }

    return { getCategories, catLoading, categories };
}

export default useGetCategories;